import { useCallback } from 'react';
import { useNavigate, type NavigateOptions } from 'react-router-dom';

/**
 * Returns a navigate function that wraps navigation in the View Transitions API
 * when supported. Falls back to regular navigation in unsupported browsers.
 */
export function useViewTransition() {
  const navigate = useNavigate();

  return useCallback(
    (to: string, options?: NavigateOptions) => {
      if (typeof document !== 'undefined' && 'startViewTransition' in document) {
        (document as Document & { startViewTransition: (cb: () => void) => void }).startViewTransition(
          () => { navigate(to, options); },
        );
      } else {
        navigate(to, options);
      }
    },
    [navigate],
  );
}
